import * as types from './constants';

// Mark Lookbook Order Placed
export const markLookbookOrderPlacedRequest = data => (
  { type: types.MARK_LOOKBOOK_ORDER_PLACED_REQUEST, payload: data }
);

export const markLookbookOrderPlacedDone = data => (
  { type: types.MARK_LOOKBOOK_ORDER_PLACED_DONE, payload: data }
);

export const markLookbookOrderPlacedFailed = errors => (
  { type: types.MARK_LOOKBOOK_ORDER_PLACED_FAILED, payload: errors }
);

export const markLookbookOrderPlacedClearErrors = prop => (
  { type: types.MARK_LOOKBOOK_ORDER_PLACED_CLEAR_ERRORS, payload: prop }
);

export const markLookbookOrderPlacedReset = () => (
  { type: types.MARK_LOOKBOOK_ORDER_PLACED_RESET }
);
